<template>
  <card-component title="Responde la siguiente pregunta" icon="ballot" :has-card-header-background="true" :has-button-slot="true">
    <form @submit.prevent="submitAnswers">
      <div v-for="item of questions" :key="item.id">
        <b-field :label="item.premise">
          <div v-if="item.label_type_answer == 'Fecha'">
            <b-datepicker
                    v-model="item.answer"
                    placeholder="DD/MM/AAAA"
                    icon="calendar-today"
                    :monthNames="monthNames"
                    trap-focus
                    editable/>
          </div>
          <div v-else>
            <b-input v-model="item.answer" type="number" required/>
          </div>
        </b-field>
        <hr>
      </div>
      <div v-if="questions != null">
        <div class="control">
          <b-button class="is-primary" native-type="submit" expanded>
            Enviar Respuesta
          </b-button>
        </div>
      </div>
    </form>
    <b-loading :is-full-page="true" :active.sync="isLoading"/>
  </card-component>
</template>

<script>
import { mapState } from 'vuex'
import CardComponent from '@/components/CardComponent'
import ClaimQuestionRepository from '@/services/ClaimQuestionRepository'
import TokenRepository from '@/services/TokenRepository'

export default {
  name: 'AnswerQuestions',
  components: { CardComponent },
  computed: {
    ...mapState([
      'idUser'
    ])
  },
  data () {
    return {
      isLoading: true,
      questions: null,
      monthNames: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre']
    }
  },
  mounted () {
    ClaimQuestionRepository.getQuestionsResponses()
      .then((r) => {
        this.isLoading = false
        this.questions = r.data
        for (let i = 0; i < this.questions.length; i++) {
          this.questions[i].answer = null
          if (this.questions[i].label_type_answer === 'Fecha') {
            this.questions[i].answer = new Date()
          }
        }
      }).catch(e => {
        this.isLoading = false
        this.$buefy.toast.open({
          message: `Error: ${e.message}`,
          type: 'is-danger'
        })
      })
  },
  methods: {
    submitAnswers () {
      this.isLoading = true
      ClaimQuestionRepository.postAnswerQuestions(
        this.idUser, this.getRequestData()
      ).then((r) => {
        // Here we re direct!
        this.requestToken(r.data)
      }).catch(e => {
        this.isLoading = false
        this.$buefy.toast.open({
          message: `Error: ${e.response.data.detail}`,
          type: 'is-danger'
        })
      })
    },
    parseDate (date) {
      return date.getDate() + '/' + (date.getMonth() + 1) + '/' + date.getFullYear()
    },
    getItemAnswer (questionId, questionAnswer) {
      return {
        question: questionId,
        answer: questionAnswer
      }
    },
    getRequestData () {
      const request = []
      let answer = null
      for (let i = 0; i < this.questions.length; i++) {
        if (this.questions[i].label_type_answer === 'Fecha') {
          answer = this.parseDate(this.questions[i].answer)
        } else {
          answer = this.questions[i].answer
        }
        request.push(this.getItemAnswer(this.questions[i].id, answer))
      }
      return request
    },
    requestToken (data) {
      TokenRepository.requestTokenSMS(this.idUser, data)
        .then((r) => {
          this.isLoading = false
          this.$store.commit('removeIDUser')
          window.location.replace(r.data.url_to_claim)
        }).catch(e => {
          this.isLoading = false
          this.showError(e.response.data.detail)
        })
    },
    getTokenSMS (token) {
      return {
        token_sms: token
      }
    },
    promptToken () {
      this.$buefy.dialog.prompt({
        message: 'Escribe el código enviado al número ' + this.phoneNumber,
        inputAttrs: {
          type: 'text'
        },
        confirmText: 'Enviar Código',
        cancelText: 'Cambiar Numero',
        trapFocus: true,
        closeOnConfirm: false,
        canCancel: ['escape', 'button'],
        onConfirm: (value, { close }) => {
          this.isLoading = true
          this.$buefy.toast.open('Validando código ...')
          TokenRepository.claimWorkplaceURL(this.idUser, this.getTokenSMS(value))
            .then((r) => {
              this.$store.commit('removeIDUser')
              window.location.replace(r.data.url_to_claim)
            }).catch(e => {
              this.isLoading = false
              this.$buefy.toast.open({
                message: `Error: ${e.response.data.detail}`,
                type: 'is-danger'
              })
            })
        },
        onCancel: () => {
          this.phoneNumber = null
        }
      })
    },
    showError (message) {
      this.$buefy.dialog.alert({
        title: 'Error',
        message: message,
        type: 'is-danger',
        ariaRole: 'alertdialog',
        ariaModal: true
      })
    }
  }
}
</script>
